import React, { FunctionComponent, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Media, RootStore } from '../app/types';

interface MediaProps {
    mediaID: number
}

export const MediaThumb: FunctionComponent<MediaProps> = (props) => {
    const mediaList = useSelector((state: RootStore) => state.media);

    const media = useMemo(() =>
        mediaList.find((m: Media) => m.ID === props.mediaID) ?? null,
        [mediaList, props.mediaID]
    );

    if (!media) return <div />;

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: 100,
            height: 100,
            justifyContent: 'center',
            cursor: 'pointer',
        }}>
            <img
                style={{
                    maxWidth: 90,
                    maxHeight: 70,
                    objectFit: 'contain',
                    borderRadius: 4,
                }}
                src={media.thumbURL}
                alt={media.shortKey}
            />
            <div style={{
                fontSize: '0.75rem',
                color: '#666',
                marginTop: 4,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                maxWidth: 90,
                textAlign: 'center',
            }}>
                {media.shortKey}
            </div>
        </div>
    );
}
